export class CascadeNode {
	/** The unique name of this node, representing its identifier in the cascade tree */
	name: string;

	/** The label of this node, which is being displayed in the dropdown or ui */
	label: string;

	/** The value of this node, used for identifying the selected option programmatically */
	value: string;

	/** The default text of this node, used as a fallback when no specific value is selected */
	defaultText: string;

	/** The rank or level of this node in the cascade tree, where 0 is the root level. */
	rank: number;

	/**
	 * A list of children node that are directly connected to this node
	 * This represents the next level of the cascade tree hierarchy
	 */
	children: CascadeNode[] = [];

	constructor(name: string, label: string, value: string, defaultText: string, rank: number) {
		this.name = name;
		this.label = label;
		this.value = value;
		this.defaultText = defaultText;
		this.rank = rank;
	}

	/**
	 * Adds a child node to the current node.
	 * Prevents adding duplicates by checking for existing children with the same value.
	 */
	addChild(childNode: CascadeNode) {
		const existingChild = this.children.find(
			(child) => child.value === childNode.value && child.label === childNode.label,
		);

		if (!existingChild) {
			this.children.push(childNode);
		}
	}
}
